<!--
 * @Author: 张家林
 * @LastEditors: 张家林
-->
<template>
  <div class="about">
    <div class="video-wrapper" v-if="map[productName].video">
      <video
        preload="auto"
        webkit-playsinline="true"
        playsinline="true"
        class="video"
        autoplay
        controls
        x5-video-player-type="h5"
        :src="map[productName].video"
        >
      </video>
    </div>
    <div class="qr-code-wrapper">
      <div class="text">
        长按图片识别下方二维码，进入{{map[productName].title}}激活页面；
      </div>
      <div class="qr-code">
        <img :src="map[productName].img" alt="" class="qr-code-img">
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'videoPlay',
    props: {
      productName: {
        type: String
      }
    },
    mounted () {

    },
    data () {
      return {
        map: {
          zhetong: {
            img: require('../assets/zhetong.png'),
            video: '',
            title: ''
          },
          sutong: {
            img: require('../assets/qr-code-suzhou.jpg'),
            video: require('../assets/jiangsu.mp4'),
            title: '苏通卡'
          },
          yuetong: {
            img: require('../assets/qr-code-guangdong.jpg'),
            video: '',
            title: ''
          },
          qiantong: {
            img: require('../assets/qr-code-guizhou.jpg'),
            video: require('../assets/guizhou.mp4'),
            title: '九州ETC'
          }
        }
      }
    }
  }
</script>
<style lang="scss" scoped>
  .about {
    background-color: #f5f5f5;
  }
  .qr-code-wrapper {
    background-color: #fff;
    padding: 0.8rem;
    margin-top: 0.3rem;
    .text {
      color: #666;
    }
    .qr-code {
      &-img {
        width: 3.6rem;
        margin-top: 0.8rem;
      }
    }
  }
  .video-wrapper {
    padding: 0.4rem 0.3rem;
    background-color: #fff;
    .video {
      width: 100%;
      height: auto;
    }
  }
</style>